__turbopack_context__.v({
  "count": "TeamList-module-scss-module__7jLZkG__count",
  "grid": "TeamList-module-scss-module__7jLZkG__grid",
  "root": "TeamList-module-scss-module__7jLZkG__root",
  "team": "TeamList-module-scss-module__7jLZkG__team",
  "title": "TeamList-module-scss-module__7jLZkG__title",
  "titleSec": "TeamList-module-scss-module__7jLZkG__titleSec",
});
